<script setup lang="ts" generic="T extends { id: string }">
import { useTemplateRefsList } from "@vueuse/core";

type Props = {
  items: T[];
  viewportOffset?: number;
};

const { viewportOffset = 10000 } = defineProps<Props>();

const refs = useTemplateRefsList<HTMLElement>();
const firstItem = computed(() => refs.value[0] ?? null);
const lastItem = computed(() => refs.value[refs.value.length - 1] ?? null);

const { y: firstY, height: firstHeight } = useElementBounding(firstItem, {
  immediate: false,
});

const { y: lastY, height: lastHeight } = useElementBounding(lastItem, {
  immediate: false,
});

const { isMinimumLg } = useScreenSize();
const showGridItem = computed(() => {
  const viewPortOffset = !isMinimumLg.value
    ? viewportOffset
    : viewportOffset / 2;

  return (
    // height = 0 means its not loaded yet
    firstHeight.value !== 0 &&
    lastHeight.value !== 0 &&
    firstY.value > -viewPortOffset &&
    lastY.value < viewPortOffset
  );
});
</script>

<template>
  <div
    v-for="item in items"
    :ref="refs.set"
    :key="item.id"
    data-test="virtualized-grid-item-container"
    :data-test-id="item.id"
    class="min-h-[1px]"
  >
    <slot
      :item="item"
      :visible="showGridItem"
    />
  </div>
</template>
